import React from 'react';
import { CustomFunctionTable } from './CustomFunctionTable';

export const CustomFunctionTab = (props) => {
  const { projectId, version, actions, flag, customFunctions } = props;
  return (
    <>
      <CustomFunctionTable
        customFunctions={customFunctions}
        projectId={projectId}
        version={version}
        actions={actions}
        flag={flag}
      />
    </>
  );
};
